import React, { useContext, useRef, useState } from "react";
import { Context, LeadMagnet, Step } from "../../components/Context";
import { Link } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import VideoEditor from "../../components/user/FunnelBuilderV2/VideoEditor";
import FormEditor from "../../components/user/FunnelBuilderV2/FormEditor";
import TextScreenEditor from "../../components/user/FunnelBuilderV2/TextScreenEditor";
import EndingEditor from "../../components/user/FunnelBuilderV2/EndingEditor";
import EditorSelection from "../../components/user/FunnelBuilderV2/EditorSelection";
import { IoDesktopOutline } from "react-icons/io5";
import { FaMobileScreen } from "react-icons/fa6";
import StepPreview from "../../components/user/FunnelBuilderV2/StepPreview";
import FunnelV2Preview from "../../components/user/sequenceInfo/FunnelV2Preview";

interface VariationProps {
    selectedMagnet : LeadMagnet,
    newABsteps : Step[],
    setNewABsteps : Function,
    setChangesMadeTo : Function,
    endingAdded : boolean,
    setEndingAdded : Function,
    selectedStep : number,
    setSelectedStep : Function,
    mobileView : boolean,
    setMobileView : Function,
    editStep : boolean,
    setEditStep : Function
}

const CreateVariation = ({ selectedMagnet, newABsteps, setNewABsteps, setChangesMadeTo, endingAdded, setEndingAdded,
    selectedStep, setSelectedStep, mobileView, setMobileView, editStep, setEditStep
 } : VariationProps) : React.ReactElement => {

    return(
        <div className="flex flex-row flex-wrap w-full items-start justify-start h-full">
            <div className="w-1/4 max-md:w-full flex flex-col h-[calc(100%-5rem)] max-md:h-[10%] shadow-lg overflow-y-scroll">
                {
                    (editStep)
                    ?<div className="bg-white">
                        <div className="w-full p-5 flex flex-row flex-wrap justify-end border-b border-b-brandLightGray z-10 sticky top-0 items-center bg-white">
                            <p className="w-1/2">Editing <span className="text-brandPurple">Step {selectedStep + 1} </span></p>
                            <p className="w-1/2 text-right text-brandPurple underline cursor-pointer" onClick={()=>{setEditStep(false);}}>Return back</p>
                        </div>
                        {newABsteps.map((step : Step, idx : number) => {
                            if(JSON.stringify(selectedMagnet.steps) !== JSON.stringify(newABsteps)){
                                setChangesMadeTo(true);
                            }else{
                                setChangesMadeTo(false);
                            }
                            if(step.action === "video" && selectedStep === idx){
                                return(
                                    <VideoEditor steps={newABsteps} setSteps={setNewABsteps} selectedStep={step} selectedStepNumber={selectedStep}/>
                                )
                            }
                            if(step.action === "form" && selectedStep === idx){
                                return(
                                    <div>
                                        <FormEditor steps={newABsteps} setSteps={setNewABsteps} selectedStep={step} selectedStepNumber={selectedStep}/>
                                    </div>
                                )
                            }
                            if(step.action === "textScreen" && selectedStep === idx){
                                return(
                                    <div>
                                        <TextScreenEditor steps={newABsteps} setSteps={setNewABsteps} selectedStep={step} selectedStepNumber={selectedStep} />
                                    </div>
                                )
                            }
                            if(step.action === "end screen" && selectedStep === idx){
                                return(
                                    <div>
                                        <EndingEditor steps={newABsteps} setSteps={setNewABsteps} selectedStep={step} selectedStepNumber={selectedStep}/>
                                    </div>
                                )
                            }
                            return null;
                        })}
                    </div>
                    :<>
                        <div className="w-full p-5 flex flex-row flex-wrap justify-start items-center border-b border-brandLightGray">
                            <p className="w-1/2">Funnel editor</p>
                        </div>
                        <EditorSelection steps={newABsteps} setSteps={setNewABsteps} selectedStep={selectedStep} setSelectedStep={setSelectedStep} setEditStep={setEditStep}
                        endingAdded={endingAdded} setEndingAdded={setEndingAdded} onlyView={true}/>
                    </>
                }
            </div>
            <div className="w-3/4 max-md:w-full flex flex-wrap gap-5 justify-center items-start p-8 h-[calc(100%-5rem)] max-md:h-[calc(90%-5rem)] bg-brandLightGray" 
            style={{backgroundImage : "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize : "5px 5px"}}>
                <div className="w-full bg-white rounded-lg p-5 gap-10 flex flex-row justify-start items-center">
                    <p className="w-3/5 text-2xl">Preview of your B-variation &#128640;</p>
                    <div className="join w-2/5 flex justify-end items-center">
                        <button className={`join-item btn font-light ${(mobileView)?"":"bg-brandPurple text-white hover:bg-brandLightPurple"}`}
                        onClick={()=>{setMobileView(false);}}><IoDesktopOutline className="size-6"/></button>
                        <button className={`join-item btn font-light ${(mobileView)?"bg-brandPurple text-white hover:bg-brandLightPurple":""}`}
                        onClick={()=>{setMobileView(true);}}><FaMobileScreen className="size-6"/></button>
                    </div>
                </div>
                {
                    (mobileView)
                    ?<div className="mockup-phone border-brandPurple bg-[#232526] h-[80%]" style={{aspectRatio :"9/18"}}>
                        <div className="mockup-phone-display h-full w-full flex justify-center items-center">
                            <StepPreview steps={newABsteps} selectedStep={selectedStep} mobile={true}/>
                        </div>
                    </div>
                    :<div className="mockup-browser border border-base-300 aspect-video h-[80%] w-full bg-[#23252680]">
                        <div className="mockup-browser-toolbar">
                            <div className="input">https://admin.cxtailor.com/funnel/...</div>
                        </div>
                        <div className="flex justify-center items-center place-content-center border-t border-base-200 bg-[#232526] h-full overflow-scroll">
                            <StepPreview steps={newABsteps} selectedStep={selectedStep} mobile={false}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default function ABtestV2 () : React.ReactElement {
    const {selectedMagnet, newABsteps, setNewABsteps, saveNewABTest, user, userToken, workspace} = useContext(Context);
    const [editStep, setEditStep] = useState<boolean>(false); 
    
    const [selectedStep, setSelectedStep] = useState<number>(0);
    const [mobileView, setMobileView] = useState<boolean>(false);

    const [endingAdded, setEndingAdded] = useState<boolean>(false);

    const [variationCreated, setVariationCreated] = useState<boolean>(false);
    const [changesMadeTo, setChangesMadeTo] = useState<boolean>(false);

    const testNameRef = useRef<HTMLInputElement>(null);
    const commentsRef = useRef<HTMLInputElement>(null);
    const [mainGoal, setMainGoal] = useState<string>();
    const [secGoal, setSecGoal] = useState<string>();

    const saveAndContinue = () => {
        saveNewABTest(
            workspace._id, userToken, user._id, selectedMagnet.form_name, selectedMagnet._id,
            testNameRef.current!.value, (commentsRef.current?.value !== null)?commentsRef.current!.value:"",
            selectedMagnet.steps, newABsteps, mainGoal, secGoal
        );
    }

    return(
        <div className="h-dvh overflow-hidden">
            <div className="flex flex-row gap-5 p-5 justify-start items-center w-full z-10 sticky shadow-md bg-brandLightGray">
                <div className="w-1/3 flex flex-row justify-start items-center gap-5">
                    <Link to="/sequences/info" className="flex flex-row justify-start items-center text-lg text-brandPurple cursor-pointer"
                    onClick={()=>{sessionStorage.clear();}}>
                        <MdArrowBackIosNew className="size-4"/>Cancel & Exit
                    </Link>
                </div>
                <div className="w-1/3 flex justify-center items-center">
                    <ul className="steps w-full">
                        <li className="step step-success cursor-pointer" onClick={()=>{setVariationCreated(false);}}>B-variation</li>
                        <li className={`step ${(variationCreated?"step-success":"")} cursor-pointer`}>Settings</li>
                    </ul>
                </div>
                <div className="w-1/3 flex justify-end">
                    {
                        (variationCreated)
                        ?<button className="btn font-light bg-brandPurple text-white hover:bg-brandLightPurple rounded-full"
                        disabled={
                            (testNameRef.current?.value === null || testNameRef.current?.value === "") ||
                            (mainGoal === null || mainGoal === undefined) || (secGoal === null || secGoal === undefined)
                        }
                        onClick={saveAndContinue}>
                            Start AB-test
                        </button>
                        :<button className="btn font-light bg-brandPurple text-white hover:bg-brandLightPurple rounded-full" disabled={!changesMadeTo}
                        onClick={()=>{setVariationCreated(true);}}>
                            Continue
                        </button>
                    }
                </div>
            </div>
            {
                (variationCreated)
                ?<div className="p-5 flex flex-wrap justify-start items-start">
                    <div className="w-1/2 p-5">
                        <p className="text-2xl mb-5">Finalize and launch your AB-test</p>
                        <p className="text-xl">Settings</p>
                        <div className="mt-5 mb-5">
                            <p>AB-test name</p>
                            <input type="text" ref={testNameRef} className="input input-bordered w-1/2" placeholder="new ab test"/>
                        </div>
                        <div className="mt-5 mb-5">
                            <p>Comments</p>
                            <input type="text" ref={commentsRef} className="input input-bordered w-1/2" placeholder="new ab test"/>
                        </div>
                        <div className="mt-5 mb-5">
                            <p>Main goal</p>
                            <select className="select select-bordered w-1/2" onChange={(e)=>{setMainGoal(e.target.value); console.log(e.target.value);}}>
                                <option disabled selected>Main goal</option>
                                <option key={0} value={JSON.stringify({step : 0, action : "start", name: "Start rate"})}>Start rate</option>
                                {newABsteps.map((step : Step, idx: number) => {
                                    return<option key={idx + 1} value={JSON.stringify({step : idx, action : "completion", name : `Step ${idx + 1}: ${step.action} completion`})}>
                                            {`Step ${idx + 1}: ${step.action} completion`}
                                        </option>
                                })}
                                <option key={newABsteps.length + 1} value={JSON.stringify({step : newABsteps.length, action : "completion", name: "Completion rate"})}>
                                    Completion rate
                                </option>
                            </select>
                        </div>
                        <div className="mt-5 mb-5">
                            <p>Secondary goal</p>
                            <select className="select select-bordered w-1/2" onChange={(e)=>{setSecGoal(e.target.value);}}>
                                <option disabled selected>Secondary goal</option>
                                <option key={0} value={JSON.stringify({step : 0, action : "start", name: "Start rate"})}>Start rate</option>
                                {newABsteps.map((step : Step, idx: number) => {
                                    return<option key={idx + 1} value={JSON.stringify({step : idx, action : "finish", name : `Step ${idx + 1}: ${step.action} completion`})}>
                                        {`Step ${idx + 1}: ${step.action} completion`}
                                        </option>
                                })}
                                <option key={newABsteps.length + 1} value={JSON.stringify({step : newABsteps.length, action : "finish", name : "Completion rate"})}>
                                    Completion rate
                                </option>
                            </select>
                        </div>
                    </div>
                    <div className="w-1/2">
                        <p className="pl-5 pt-5 pb-5 text-xl">Preview of the B-variant:</p>
                        <div className="w-full h-0 pb-[calc(56%)] rounded-xl border-solid border-4 border-brandPurple shadow-md relative">
                            <FunnelV2Preview steps={newABsteps} mobile={false} embed={true}/>
                        </div>
                    </div>
                </div>
                :<CreateVariation newABsteps={newABsteps} setNewABsteps={setNewABsteps} setChangesMadeTo={setChangesMadeTo}
                endingAdded={endingAdded} setEndingAdded={setEndingAdded} mobileView={mobileView} setMobileView={setMobileView} editStep={editStep} setEditStep={setEditStep}
                selectedStep={selectedStep} setSelectedStep={setSelectedStep} selectedMagnet={selectedMagnet}/>
            }
        </div>
    );
};
